import { useQuery } from '@tanstack/react-query';
import { getBrands } from '../../api/apiBrands';

/**
 * Hook to fetch all active brands for select components
 */
export const useGetBrandsForSelect = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['brands-select'],
        queryFn: () => getBrands({ per_page: 100, is_active: 1 }), // Get a large batch of active brands
        retry: false,
    });

    return {
        options: data?.data || [],
        isLoading,
        error
    };
};
